import { useEffect, useState } from 'react'

import { publicIpv4 } from '@hublo/public-ip'

export const useIpAddress = (): string => {
  const [ipAddress, setIpAddress] = useState('')

  useEffect(() => {
    const getIpAddress = async () => {
      try {
        const ip = await publicIpv4()
        setIpAddress(ip)
      } catch (_) {
        setIpAddress('8.8.8.8')
      }
    }
    void getIpAddress()
  }, [])

  return ipAddress
}
